import ColorMenu from './ColorMenu';

export * from './ColorMenu';

export default ColorMenu;
